window.setTimeout(function() {
  var s = document.createElement('script');
  s.type = "text/javascript";
  s.async = false;
  s.src = "//a.klaviyo.com/media/js/onsite/onsite.js";
  s.onload = function() {
    klaviyo.init({
      account: "QkCWPk",
      list: 'QyYtHn',
      platform: "shopify"
    });

    klaviyo.enable("backinstock",{
      trigger: {
        product_page_text: "Notify Me When Available",
        product_page_class: "button button-secondary",
        replace_anchor: false
      },
      modal: {
        headline: "{product_name}",
        body_content: "Enter your email to be notified when this item comes back in stock.",
        email_field_label: "Email",
        button_label: "Notify Me When Available",
        subscription_success_label: "You're in! We'll let you know when it's back.",
        footer_content: '',
        drop_background_color: "#000",
        background_color: "#fff",
        text_color: "#222",
        button_text_color: "#fff",
        button_background_color: "#212A2F",
        close_button_color: "#ccc",
        error_background_color: "#fcd6d7",
        error_text_color: "#C72E2F",
        success_background_color: "#d3efcd",
        success_text_color: "#1B9500"
      }
    });
  };

  document.body.appendChild(s);
}, 100);
